import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {TrainingService} from './training.service';
import {DomSanitizer} from '@angular/platform-browser';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-training',
  templateUrl: './training.component.html',
  styleUrls: ['./training.component.css', './editorTranning.component.css'],
  providers: [TrainingService],
  encapsulation: ViewEncapsulation.None
})
export class TrainingComponent implements OnInit {
  public activeTab: Number = 1;
  public titles = [];
  public currentId?: number;
  public contentTraining: any = [];
  public evs_page = document.getElementById('evs_page');
  public heading: string = "";

  public icons = [
    { id: 1, src: '/assets/images/14-a.png' },
    { id: 2, src: '/assets/images/13-a.png' },
    { id: 3, src: '/assets/images/12-a.png' },
    { id: 4, src: '/assets/images/11-a.png' },
    { id: 5, src: '/assets/images/5-a.png' },
    { id: 6, src: '/assets/images/10-a.png' },
    { id: 7, src: '/assets/images/9-a.png' },
    { id: 8, src: '/assets/images/6-a.png' },
    { id: 9, src: '/assets/images/7-a.png' },
    { id: 10, src: '/assets/images/2-a.png' },
    { id: 11, src: '/assets/images/15-a.png' },
    { id: 12, src: '/assets/images/1-a.png' },
    { id: 13, src: '/assets/images/3-a.png' },
  ];

  constructor(
    private _trainingService: TrainingService,
    public sanitizer: DomSanitizer,
    private translate: TranslateService
  ) {
  }

  ngOnInit() {
    this.loadMenu();

    this.translate.onLangChange.subscribe(() => {
      this.loadMenu();
    });

    this.activeTabTitle();
    this.scrollToTop(false);
  }

  loadMenu() {
    this._trainingService
      .getTrainingMenu()
      .subscribe(
        res => {
          console.info('menu: ', res);
          if (res.status === 200) {
            this.titles = res.data;
            if (this.titles && this.titles.length > 0) {
              this.currentId = this.titles[0].id;
              this.getContentDetail(this.currentId);
            }
          }
        },
        err => {
          console.error('Error Training: ', err);
        }
      );
  }

  getContentDetail(id: number) {
    console.log('tuanbbasd', id)
    this._trainingService.getTrainingContent(id).subscribe(res => {
        console.info('content: ', res.data);
        if (res.code === 1) {
          this.heading = this.titles[id - 1].title;
          this.contentTraining = res.data;
        }
      },
      err => {
        console.error('Error Content Detail: ', err);
      }
    )
  }


  activeTabTitle() {
    const header = document.getElementById('menu-content-training');
    const btns = header.getElementsByClassName('menu-content-item');
    for (let i = 0; i < btns.length; i++) {
      btns[i].addEventListener('click', function () {
        const current = document.getElementsByClassName('active');
        if (current.length > 0) {
          current[0].className = current[0].className.replace(' active', '');
        }
        this.className += ' active';
      });
    }
  }

  changeTitle(value: any, id: number) {
    this.activeTab = value;
    this.currentId = id;
    this.getContentDetail(this.currentId);
    this.scrollToTop(false);
    // console.info("titles: ", this.contentTraining);
  }

  scrollToContent(title_id: number) {
    const pageDetails = document.querySelector('.page-layout-detail');
    const yOffset = -100;
    const element = document.getElementById(`title${title_id}`);
    const y = element.getBoundingClientRect().top + window.scrollY + yOffset;
    pageDetails.scrollTo({ top: y, behavior: 'smooth' });
  }

  scrollToTop(isSmooth: boolean) {
    document.querySelector('.page-layout-detail').scrollTo({ top: 0, behavior: isSmooth ? 'smooth' : 'auto' });
    window.scrollTo({ top: 0, behavior: isSmooth ? 'smooth' : 'auto' });
  }

  indentTitle(title: string) {
    const numbers = title.match(/\d+/g);
    return `${numbers ? (numbers.length - 1) * 10 : 0}px`;
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/training/training.component.ts